import { AssetWithSeriesId } from 'types';

import { CollectionAsset, CollectionLinkAsset, convertRhinoAssetTypeToMediaType } from '@kaltura-ott/tvpil-shared';

import { resolveLinkAsAsset, resolveLinkProgramAsset } from 'components/presenters/Card/helpers';
import { FROM_REFERENCE_ID } from 'consts';
import { useMenuStore, usePageId, useSearchParam } from 'hooks';

interface Props {
  data: CollectionAsset;
  isSingleVod: boolean;
  isFutureProgram: boolean;
  collectionType: string | undefined;
  isLinkAsAsset: boolean;
  isChannelAsset: boolean;
  isAsPlayAsset: boolean;
  isProgramLive: boolean;
  hasNoDirectPlayback: boolean;
}

function useCollectionCardLink({
  data,
  isSingleVod,
  isLinkAsAsset,
  isFutureProgram,
  collectionType,
  isChannelAsset,
  isAsPlayAsset,
  hasNoDirectPlayback,
  isProgramLive,
}: Props) {
  const menuStore = useMenuStore();
  const pageId = usePageId();
  const referenceId = useSearchParam(FROM_REFERENCE_ID) || pageId;
  const mediaTypeParam = convertRhinoAssetTypeToMediaType(data.type);
  let link: string = '';

  if (isLinkAsAsset) {
    link = resolveLinkAsAsset({ data: data as CollectionLinkAsset, menuStore, referenceId }) ?? '';
  } else {
    link = resolveLinkProgramAsset({
      data: data as AssetWithSeriesId,
      collectionType,
      mediaTypeParam,
      isFutureProgram,
      isSingleVod,
      isAsPlayAsset,
      isChannelAsset,
      isProgramLive,
      hasNoDirectPlayback,
    });
  }

  return { link, mediaTypeParam };
}

export { useCollectionCardLink };
